<script>
  import { mapGetters, mapMutations } from 'vuex'

  import { ACCOUNT_STATUS } from '@/utils/accountStatus'

  export default {
    computed: {
      ...mapGetters(['getAccount', 'hasAccount']),
      accountIsClosed() {
        return !!this.getAccount && this.getAccount.subscriptionType === ACCOUNT_STATUS.CANCELED
      },
      isSemParar() {
        return this.getAccount && this.getAccount.metadata.semParar
      }
    },
    methods: {
      ...mapMutations(['setAccount'])
    },
    name: 'GetAccount'
  }
</script>
